<div class="d-flex">
    <li>
        <div kendoTooltip class="grid-tooltip" position="bottom" [title]="'Clear Filter'">
            <a href="javascript:;" class="btn btn-primary btn-sm" (click)="clearFilter()">
                <span><img class="clearfilter-icon" height="19" width="19" /></span>
            </a>
        </div>
    </li>
    <li>
        <div kendoTooltip class="grid-tooltip" position="bottom" [title]="'Filter Data'">
            <a href="javascript:;" class="btn btn-primary btn-sm" (click)="filterOpen()">
                <span style="color: white;">
                    <img class="filterdata-icon" height="19" width="19" />&nbsp;&nbsp;Filter
                </span>
            </a>
        </div>
    </li>
</div>